/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration for Lucene syntax queries. Used as an alternative to SQL queries for searching logs data. 
*/
export class LuceneQueryInput {
  /**
  * Lucene syntax query to search logs data. This will be translated to SQL/KQL based on the cloud provider. 
  */
  'query': string;
  /**
  * Name of the table to query. 
  */
  'tableName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableName",
      "baseName": "tableName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LuceneQueryInput.attributeTypeMap;
  }

  public constructor() {
  }
}

